@let model = modelSg();
@let modelName = modelNameSg();
@let breadcrumbs = breadcrumbsSg();
@let modelDescription = modelDescriptionSg();
@let entityLevel = entityLevelSg();
@let entityParentName = entityParentNameSg();
@let entityChildName = entityChildNameSg();
@let entityDimensionName = entityDimensionNameSg();
@let modelId = modelIdSg();
@let partialId = partialIdSg();
@let modelIsStandard = modelIsStandardSg();
@let hasRecordDeletions =
  recordsEc.plugins.editingPlugin.feature.selectors.hasDeletions.asSignal();

<atn-ds-page>
  <atn-ds-page-header
    pageHeader
    [name]="modelName"
    [breadcrumbs]="breadcrumbs"
  />

  <div class="atn-entity">
    <atn-ds-floating-horizontal-tabs
      enableQueryParamPersistenceUnderKey="dmsEntityTab"
    >
      <ng-template
        atnDsTab
        name="General"
      >
        <div class="atn-entity__general">
          <div class="atn-entity__main">
            <atn-ds-widget title="Entity Summary">
              <div class="atn-entity__widget-content atn-entity__summary">
                <div>
                  {{ modelDescription }}
                </div>
                <div class="atn-entity__attributes">
                  <div class="atn-entity__attribute">
                    <div class="atn-entity__attribute-name">Name</div>
                    <div class="atn-entity_attribute-value">
                      {{ modelName }}
                    </div>
                  </div>
                  @if (isEntity(model)) {
                    <div class="atn-entity__attribute">
                      <div class="atn-entity__attribute-name">Level</div>
                      <div class="atn-entity__attribute-value">
                        {{ entityLevel }}
                      </div>
                    </div>
                    <div class="atn-entity__attribute">
                      <div class="atn-entity__attribute-name">Parent</div>
                      <div class="atn-entity__attribute-value">
                        {{ entityParentName ?? 'N/A' }}
                      </div>
                    </div>
                    <div class="atn-entity__attribute">
                      <div class="atn-entity__attribute-name">Child</div>
                      <div class="atn-entity__attribute-value">
                        {{ entityChildName ?? 'N/A' }}
                      </div>
                    </div>
                  }
                </div>
                <div class="atn-entity__attributes">
                  <div class="atn-entity__attribute">
                    <div class="atn-entity__attribute-name">Dimension</div>
                    <!-- TODO: fix issue where 'entityDimensionNameSg' evaluates
                    into falsy value -->
                    <div class="atn-entity_attribute-value">
                      {{ entityDimensionName ?? 'TODO' }}
                    </div>
                  </div>
                  <div class="atn-entity__attribute">
                    <div class="atn-entity__attribute-name">ID</div>
                    <div class="atn-entity__attribute-value">
                      {{ modelId }}
                    </div>
                  </div>
                  <div class="atn-entity__attribute">
                    <div class="atn-entity__attribute-name">Partial ID</div>
                    <div class="atn-entity__attribute-value">
                      <!-- TODO: fix issue where 'partialIdSg' evaluates
                    into falsy value -->
                      {{ partialId ?? 'TODO' }}
                    </div>
                  </div>
                  <div class="atn-entity__attribute">
                    <div class="atn-entity__attribute-name">
                      Standard {{ isEntity(model) ? 'Entity' : 'Snapshot' }}
                    </div>
                    <!-- TODO: fix issue where 'entityIsStandardSg' evaluates
                    into falsy value -->
                    <div class="atn-entity__attribute-value">
                      {{ modelIsStandard }}
                    </div>
                  </div>
                </div>
              </div>
            </atn-ds-widget>
            <div class="atn-entity__attributes-table-container">
              <atn-ds-table [config]="attributesTableConfig" />
            </div>
          </div>
          <div class="atn-entity__side">
            <atn-ds-widget title="Notes">
              <div class="atn-entity__widget-content">
                <!-- TODO: finish implementing terms -->
                Coming soon!
              </div>
            </atn-ds-widget>
          </div>
        </div>
      </ng-template>
      <ng-template
        atnDsTab
        name="Data"
      >
        <div class="atn-entity__record">
          <atn-ds-table [config]="recordsTableConfigSg()" />
        </div>
      </ng-template>
    </atn-ds-floating-horizontal-tabs>

    @if (hasRecordDeletions) {
      <atn-ds-confirmation-overlay
        title="Delete Entity Record"
        description="Are you sure that you want to delete this record?"
        (cancel)="cancelDeletionClickHandler()"
        (confirm)="confirmDeletionClickHandler()"
        confirmButtonText="Delete"
      />
    }
    <atn-edit-record-dialog />
  </div>
</atn-ds-page>
